var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.75V7.25",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.75V7.25",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 11.375H27.875",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.125 4.5H5.875C4.35562 4.5 3.125 5.73062 3.125 7.25V25.125C3.125 26.6444 4.35562 27.875 5.875 27.875H25.125C26.6444 27.875 27.875 26.6444 27.875 25.125V7.25C27.875 5.73062 26.6444 4.5 25.125 4.5Z",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5177 16.5024C15.3279 16.5024 15.1739 16.6564 15.1753 16.8462C15.1753 17.0359 15.3293 17.1899 15.519 17.1899C15.7088 17.1899 15.8628 17.0359 15.8628 16.8462C15.8628 16.6564 15.7088 16.5024 15.5177 16.5024",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3927 16.5024C22.2029 16.5024 22.0489 16.6564 22.0503 16.8462C22.0503 17.0359 22.2043 17.1899 22.394 17.1899C22.5838 17.1899 22.7378 17.0359 22.7378 16.8462C22.7378 16.6564 22.5838 16.5024 22.3927 16.5024",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64267 22.0024C8.45292 22.0024 8.29892 22.1564 8.3003 22.3462C8.3003 22.5359 8.4543 22.6899 8.64405 22.6899C8.8338 22.6899 8.9878 22.5359 8.9878 22.3462C8.9878 22.1564 8.8338 22.0024 8.64267 22.0024",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5177 22.0024C15.3279 22.0024 15.1739 22.1564 15.1753 22.3462C15.1753 22.5359 15.3293 22.6899 15.519 22.6899C15.7088 22.6899 15.8628 22.5359 15.8628 22.3462C15.8628 22.1564 15.7088 22.0024 15.5177 22.0024",
    stroke: "#5371ff",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.42dbaaf02f912970334a8290a0c61f05.svg";
export { ForwardRef as ReactComponent };